import React, { useEffect, useState, useContext } from "react";
import MyContext from "../../context/MyContext";
import AuthContext from "../../context/userAuth.context";
import Swal from "sweetalert2";

const lockFontIndices = [4, 7, 11, 14, 22]

const Fonts = ({
  fontName,
  fontFamily,
  googleFontUrl,
  layervalue,
  isAnimatedText,
  index,
  fontStyle,
  setselectedAnimatedText,
  selectedAnimatedText,
  ComingFromAsset,
  rowIndex = -1
}) => {
  var FontFaceObserver = require("fontfaceobserver");
  const [FontAvailable, setFontAvailable] = useState(false);

  const { setLayersData, LayersData } = useContext(MyContext);
  const { Access, getLink } = useContext(AuthContext);

  const setFont = () => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === layervalue.key) {
        array[i].googleFontSetting = {
          fontName: fontName,
          fontFamily: fontFamily,
          googleFontUrl: googleFontUrl,
        };
      }
    }
    setLayersData(array);
    //close('');
  };

  const setAnimatedFont = () => {
    var duplicatedFont = JSON.parse(
      JSON.stringify(layervalue.JSONValue.fonts.list[0])
    );
    duplicatedFont.fFamily = fontFamily;
    duplicatedFont.fName = fontName;
    duplicatedFont.fPath = googleFontUrl;
    duplicatedFont.fStyle = fontStyle;

    layervalue.JSONValue.fonts.list.push(duplicatedFont);
    var fontlistInsideJSON = layervalue.JSONValue.fonts.list;
    // fontlistInsideJSON[0].fFamily = fontFamily;
    // fontlistInsideJSON[0].fName = fontName;
    // fontlistInsideJSON[0].fPath = googleFontUrl;
    // fontlistInsideJSON[0].fStyle = fontStyle;

    if (ComingFromAsset) {
      var layers = layervalue.JSONValue.assets;
      layers[index].layers[0].t.d.k[0].s.f = fontName;
    } else {
      var layers = layervalue.JSONValue.layers;
      layers[index].t.d.k[0].s.f = fontName;
    }

    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == layervalue);

    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = layervalue;
    setFont();
    setLayersData(_array);

    setselectedAnimatedText({
      ...selectedAnimatedText,
      fontfamily: fontName,
    });

    //close('');
  };
  useEffect(() => {
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", googleFontUrl);
    document.getElementsByTagName("head")[0].appendChild(link);
    var font = new FontFaceObserver(fontName);
    font.load().then(
      function () {
        setFontAvailable(true);
      },
      function () {
        setFontAvailable(false);
      }
    );
  }, []);

  const fontClickHandler = ()=>{
    if(Access == "FE" && lockFontIndices.includes(rowIndex)){
      Swal.fire({
        title: "Upgrade Required",
        html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
      return;
    }
    else{
      !isAnimatedText ? setFont() : setAnimatedFont()
    }
  }

  return (
    <>
      {FontAvailable &&
        (!isAnimatedText ? (
          <div
            className={
              layervalue.googleFontSetting.fontFamily.toLowerCase() ==
              fontFamily.toLowerCase()
                ? "fontDropDownitem active"
                : "fontDropDownitem"
            }
            onClick={fontClickHandler}
            style={{ fontFamily: fontFamily, position:"relative" }}
          >
            {fontName}
            {Access == "FE" && lockFontIndices.includes(rowIndex) && (
            <img
              className="iconUS"
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
              // style={{position: "relati"}}
            />)}
          </div>
        ) : (
          <div
            className={
              layervalue.JSONValue.fonts.list[0].fName.toLowerCase() ==
              fontName.toLowerCase()
                ? "fontDropDownitem active"
                : "fontDropDownitem"
            }
            onClick={fontClickHandler}
            style={{ fontFamily: fontFamily, fontStyle: fontStyle }}
          >
            {fontName}
            {Access == "FE" && lockFontIndices.includes(rowIndex) && (
            <img
              className="iconUS"
              src="../AppIcons/IconsAll/PremiumIcon.svg"
              alt=""
            />)}
          </div>
        ))}
      {!FontAvailable && (
        <div className="fontDropDownitem">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Fonts;
